// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HideNoDispositionsBadgeMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEntityInput;
}>;


export type HideNoDispositionsBadgeMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CLTTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CRTTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CustodialPersonalAccount', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'DonorAdvisedFund', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'GPBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'GRATTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'ILITTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'IndividualPersonalAccount', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'InsurancePersonalAccount', beneficiaryDesignationsReviewedAt?: Time | null, id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'IrrevocableTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'JointPersonalAccount', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'LLCBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'LPBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'PrivateFoundation', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'QPRTTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'RetirementPersonalAccount', beneficiaryDesignationsReviewedAt?: Time | null, id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'RevocableTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SCorpBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SLATTrust', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } } };

export const Operations = {
  Mutation: {
    HideNoDispositionsBadge: 'HideNoDispositionsBadge' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const HideNoDispositionsBadgeDocument = gql`
    mutation HideNoDispositionsBadge($input: AugmentedUpdateEntityInput!) {
  updateEntity(input: $input) {
    id
    subtype {
      id
      dispositionScenarios {
        id
        reviewedAt
      }
      ... on RetirementPersonalAccount {
        beneficiaryDesignationsReviewedAt
      }
      ... on InsurancePersonalAccount {
        beneficiaryDesignationsReviewedAt
      }
    }
  }
}
    `;
export type HideNoDispositionsBadgeMutationFn = Apollo.MutationFunction<HideNoDispositionsBadgeMutation, HideNoDispositionsBadgeMutationVariables>;

/**
 * __useHideNoDispositionsBadgeMutation__
 *
 * To run a mutation, you first call `useHideNoDispositionsBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideNoDispositionsBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideNoDispositionsBadgeMutation, { data, loading, error }] = useHideNoDispositionsBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHideNoDispositionsBadgeMutation(baseOptions?: Apollo.MutationHookOptions<HideNoDispositionsBadgeMutation, HideNoDispositionsBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideNoDispositionsBadgeMutation, HideNoDispositionsBadgeMutationVariables>(HideNoDispositionsBadgeDocument, options);
      }
export type HideNoDispositionsBadgeMutationHookResult = ReturnType<typeof useHideNoDispositionsBadgeMutation>;
export type HideNoDispositionsBadgeMutationResult = Apollo.MutationResult<HideNoDispositionsBadgeMutation>;
export type HideNoDispositionsBadgeMutationOptions = Apollo.BaseMutationOptions<HideNoDispositionsBadgeMutation, HideNoDispositionsBadgeMutationVariables>;